<template>
	<div
		id="data-list-list-view"
		class="data-list-container"
	>
		<vs-popup
			class="holamundo"
			:title="modalType == 'edit' ? 'Dolgozó módosítása' : 'Új dolgozó'"
			:active.sync="workerModal"
		>
			<form
				data-vv-scope="worker"
				v-on:submit.prevent
			>
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Vezetéknév"
								v-model="worker.firstName"
								class="w-full mt-4"
								name="firstName"
								v-validate="'required'"
								v-on:keyup.enter="validate"
							/>
							<span class="text-danger">{{ errors.first('worker.firstName') }}</span>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="6"
							class="p-2"
						>
							<vs-input
								label-placeholder="Keresztnév"
								v-model="worker.lastName"
								class="w-full mt-4"
								name="lastName"
								v-validate="'required'"
								v-on:keyup.enter="validate"
							/>
							<span class="text-danger">{{ errors.first('worker.lastName') }}</span>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-input
								label-placeholder="E-mail cím"
								v-model="worker.email"
								class="w-full mt-4"
								name="email"
								v-validate="'required'"
								v-on:keyup.enter="validate"
							/>
							<span class="text-danger">{{ errors.first('worker.email') }}</span>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="6"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="validate()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<div
			id="loading-bg"
			v-if="loading"
		>
			<div class="loading">
				<div class="effect-1 effects"></div>
				<div class="effect-2 effects"></div>
				<div class="effect-3 effects"></div>
			</div>
		</div>
		<vx-card>
			<div class="flex">
				<vs-button
					color="primary"
					size="medium"
					type="flat"
					icon="icon-arrow-left"
					icon-pack="feather"
					@click="$router.go(-1)"
				></vs-button>
				<h4 class="mt-3">
					Dolgozók
				</h4>
				<div class="rounded-lg cursor-pointer items-center justify-center right-button">
					<vs-button
						color="primary"
						size="large"
						class="pull-right btn-add-new"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click="addNewData"
					>
						Új dolgozó
					</vs-button>
				</div>
			</div>
			<vs-table
				v-model="selected"
				@selected="editData(selected)"
				v-if="workers"
				pagination
				maxItems="30"
				:hoverFlat="true"
				:notSpacer="true"
				:data="workers"
				noDataText="Nincs találat"
			>

				<div
					slot="header"
					class="flex flex-wrap-reverse items-center flex-grow justify-between mb-6"
				>
					<div class="flex flex-wrap-reverse items-center data-list-btn-container">
						<!-- Input search -->
					</div>
					<div class="rounded-lg cursor-pointer items-center justify-center">

					</div>
				</div>

				<template slot="thead">
					<vs-th sort-key="firstName">Vezetéknév</vs-th>
					<vs-th sort-key="lastName">Keresztnév</vs-th>
					<vs-th sort-key="lastName">E-mail cím</vs-th>
					<vs-th></vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
						<vs-tr
							:data="worker"
							:key="index"
							v-for="(worker, index) in data"
						>

							<vs-td :data="worker.firstName">
								<p class="product-name font-medium truncate">{{ worker.firstName }}</p>
							</vs-td>

							<vs-td :data="worker.lastName">
								<p class="product-category">{{ worker.lastName }}</p>
							</vs-td>

							<vs-td :data="worker.email">
								<p class="product-category">{{ worker.email }}</p>
							</vs-td>

							<vs-td class="whitespace-no-wrap">
								<div class="flex pull-right">
									<vx-tooltip text="Módosítás">
										<vs-button
											type="border"
											size="medium"
											icon-pack="feather"
											icon="icon-edit"
											class="mr-2"
											color="dark"
											@click.stop="editData(worker)"
										></vs-button>
									</vx-tooltip>
									<vx-tooltip text="Törlés">
										<vs-button
											type="border"
											size="medium"
											icon-pack="feather"
											icon="icon-trash-2"
											color="danger"
											class="mr-2"
											@click="deleteData(worker.id)"
										></vs-button>
									</vx-tooltip>
								</div>
							</vs-td>

						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
	custom: {
		firstName: {
			required: 'Vezetéknév megadása kötelező.',
		},
		lastName: {
			required: 'Keresztnév megadása kötelező.',
		},
	}
};
Validator.localize('en', dict);
export default {

	// register custom messages
	components: {
	},
	data() {
		return {
			modalType: '',
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			workerModal: false,
			loading: true,
			workers: null,
			worker: {
				firstName: '',
				lastName: '',
				email: ''
			}
		}
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx
			}
			return 0
		}
	},
	watch: {
	},
	methods: {
		fetch() {
			this.$http.get("/api/users/list/worker")
				.then((response) => {
					this.workers = response.data.data
					this.loading = false
				})
				.catch((error) => { console.log(error) })
		},
		addNewData() {
			this.modalType = 'create'
			this.workerModal = true
		},
		deleteData(id) {
			event.stopPropagation();
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				text: '',
				accept: this.confirmDelete,
				parameters: id
			})
		},
		confirmDelete(id) {
			this.$http.delete("/api/users/delete/" + id)
				.then(() => {
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres törlés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch();
				})
				.catch((error) => { console.log(error) })
		},
		editData(worker) {
			this.modalType = 'edit'
			this.worker = worker
			this.workerModal = true
		},
		validate() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("worker").then(result => {
					if (result) {
						this.save()
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})


		},
		save() {
			this.$vs.loading()
			var postMethod = ''
			switch (this.modalType) {
				case 'create':
					postMethod = 'create'
					break;

				case 'edit':
					postMethod = 'update/' + this.worker.id
					break;

				default:
					this.$vs.notify({
						title: 'Hiba',
						text: 'Ismeretlen metódus',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
					break;
			}

			this.$http.post("/api/users/" + postMethod, this.worker)
				.then(() => {
					this.$vs.loading.close()
					this.fetch();
					this.workerModal = false
					this.worker = {}
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				}).catch(error => {
					console.log(error);
					this.$vs.loading.close()
				})
		}
	},
	created() {
		this.fetch()
	},
	mounted() {
		this.isMounted = true;
	}
}
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 0rem;
			margin-right: 0rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				background-color: #fff;
				padding-top: 10;
				padding-bottom: 10;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
